module.exports = __webpack_public_path__ + "static/media/get-recommendations-tabletPro-es.0f78edd5.webp";